import Query from '../utils/Query';

export default class LanguageService {

	static getAll() {
		return Query.get('/items/language');
	}
}
